import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import {Button, TYPES} from './../shared/button'
import './../../styles/admin/adminUserTable.css'

class AdminUserTable extends React.Component {

  render () {
    const { locations } = this.props.locations
    return (
      <div className="admin-user-table">
        <table className='recordings-table'>
          <thead>
            <tr>
              <th className='admin-user-header'>ID</th>
              <th className='admin-user-header'>Location Name</th>
              <th className='admin-user-header'>Bays</th>
              <th className='admin-user-header'>Bay IDs</th>
              <th className='admin-user-header'>Actions</th>
            </tr>
          </thead>
          <tbody>
        {locations &&

          locations.map((location, index)=> {
            return(
              <tr key={"admin" + index} className='admin-row'>
                <td>{location.id}</td>
                <td>{location.name}</td>
                <td>{location.bays.length}</td>
                <td className='bay-id'>
                  {location.bays.map(bay => bay.id).join(', ')}
                </td>
                <td>
                  <Link to={`/admin/locations/${location.id}`}>
                    <Button
                      text='Details'
                      type='admin'
                      onClick={() => {this.openModal()}}
                      buttonType={TYPES.DEFAULT}
                    />
                  </Link>
                </td>
              </tr>
            )
        })
      }
        </tbody>
      </table>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

export default connect(mapStateToProps)(AdminUserTable);



// WEBPACK FOOTER //
// ./src/components/admin/adminUserTable.js